export default "__VITE_ASSET__CsPR4syP__";